import WithPermissionRestricted from '../../../../../general/hoc/WithPermissionRestricted'
import {PaymentDashboardProvider} from './PaymentDashboard'
import PaymentDashboardLayout from './PaymentDashboardLayout'

function PaymentDashboardWrapper() {

  return (
    <PaymentDashboardProvider>
      <PaymentDashboardLayout />
    </PaymentDashboardProvider>
  )
}

export default WithPermissionRestricted(PaymentDashboardWrapper, 'FILTERS', [
  'payments',
  'GetAllPayments',
])

/**
 * Todo: Don't forget to do this in PROD and for each role, right now it is just for role admin retailer 1
 * Added the following permissions to each role and permission schema:
 * 
 * {
            payments: {
                allowed: [
                    'GetAllPayments'
                ],
                name: 'Payments',
                createdAt: ISODate('2024-06-05T11:57:03.758Z'),
                updatedAt: ISODate('2024-06-05T11:57:03.758Z')
            }
        },


 */